import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './ui/SectionHeading';
import { XCircle, CheckCircle2 } from 'lucide-react';
const comparisons = [{
  bad: '3 a 5 horas semanales improvisando y buscando en internet qué hacer con casos difíciles.',
  good: '10 minutos de preparación de sesión usando tus fichas de diagnóstico cruzado ya listas.'
}, {
  bad: 'Sesiones repetitivas basadas únicamente en el discurso mental del paciente.',
  good: 'Integración del cuerpo, el sistema y el alma para resultados visibles en menos de 4 semanas.'
}, {
  bad: 'Temor constante a no sonar lo suficientemente profesional o científico ante tus colegas.',
  good: 'Rigor epistemológico impecable respaldado por psicología transpersonal y neurobiología.'
}, {
  bad: 'Dependencia de cobrar por hora de sesión suelta, limitando tus ingresos mensuales.',
  good: 'Estructura para ofrecer un programa premium de alto valor, duplicando tus ingresos por paciente.'
}];
export const Comparison = () => {
  return <section className="py-24 bg-cream relative" data-id="element-43">
      <div className="container mx-auto px-6" data-id="element-44">
        <SectionHeading title="LA REALIDAD CLÍNICA" subtitle="¿Cuánto te cuesta NO tener este sistema?" data-id="element-45" />

        <div className="max-w-5xl mx-auto" data-id="element-46">
          <div className="grid md:grid-cols-2 gap-0 rounded-sm overflow-hidden shadow-2xl border border-gold-500/20" data-id="element-47">
            {/* Bad Side */}
            <div className="bg-white p-8 md:p-12" data-id="element-48">
              <h3 className="font-serif text-2xl font-bold text-navy mb-8 text-center pb-4 border-b border-gray-200" data-id="element-49">
                Sin el Sistema "La Memoria del Alma"
              </h3>
              <ul className="space-y-8" data-id="element-50">
                {comparisons.map((item, i) => <motion.li key={i} initial={{
                opacity: 0,
                x: -20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: i * 0.1
              }} className="flex gap-4 items-start" data-id="element-51">
                    <XCircle className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-52" />
                    <span className="text-navy/70 leading-relaxed" data-id="element-53">
                      {item.bad}
                    </span>
                  </motion.li>)}
              </ul>
            </div>

            {/* Good Side */}
            <div className="bg-navy p-8 md:p-12 text-cream relative" data-id="element-54">
              <div className="absolute inset-0 bg-noise opacity-20 pointer-events-none" data-id="element-55"></div>
              <h3 className="font-serif text-2xl font-bold text-gold-400 mb-8 text-center pb-4 border-b border-gold-500/30 relative z-10" data-id="element-56">
                Con el Sistema "La Memoria del Alma"
              </h3>
              <ul className="space-y-8 relative z-10" data-id="element-57">
                {comparisons.map((item, i) => <motion.li key={i} initial={{
                opacity: 0,
                x: 20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: i * 0.1
              }} className="flex gap-4 items-start" data-id="element-58">
                    <CheckCircle2 className="w-6 h-6 text-gold-400 flex-shrink-0 mt-1" data-id="element-59" />
                    <span className="text-cream-200 leading-relaxed" data-id="element-60">
                      {item.good}
                    </span>
                  </motion.li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
};